import script from "./DeleteCheckPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteCheckPoint.vue?vue&type=script&setup=true&lang=js"

import "./DeleteCheckPoint.vue?vue&type=style&index=0&id=16fab02b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fab02b"]])

export default __exports__